import React from "react";
import { Card } from 'react-bootstrap';

export default function ArticleCard({ data }) {
    return (
        <Card className = "h-100 shadow-sm card-theme rounded">
            <Card.Img variant="top" src={data.image} style={{ height: '200px', objectFit: 'contain', objectPosition: 'center' }} />
            <Card.Body className="d-flex flex-column">
                <div className="d-flex mb-2 justify-content-between">
                    <Card.Title className="mb-0 font-weight-bold text-theme-accent2">{data.title}</Card.Title>
                </div>
                <Card.Subtitle className="text-theme-accent3">{data.date}</Card.Subtitle>
                <p/>
                <Card.Text className="text-theme-accent3">{data.summary}</Card.Text>
                <a href={"/articles/" + data.link} className="btn btn-dark mt-auto font-weight-bold">Read it</a>
            </Card.Body>
        </Card>
    )
}
